/** The API's metadata and request-time policy own provider/registration controls. */
export function assertWebAuthRequestAllowed(url: URL | string) {
  const path = new URL(url).pathname.replace(/\/+$/, "");
  if (path === "/auth/admin" || path.startsWith("/auth/admin/")) throw new Error("Administrator actions require the TripBears REST API.");
}
